import { render, staticRenderFns } from "./UFooter.vue?vue&type=template&id=db8bd956&"
import script from "./UFooter.vue?vue&type=script&lang=js&"
export * from "./UFooter.vue?vue&type=script&lang=js&"
import style0 from "./UFooter.vue?vue&type=style&index=0&id=db8bd956&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports